module.exports = __webpack_public_path__ + "img/Huimin_Lu@2x.cb368acb.png";